/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { EnhanceMixEffect } from "./EnhanceMixEffect";
import { BackgroundEffect } from "./BackgroundEffect";
import { LongFadeInEffect } from "./LongFadeInEffect";
import { LongFadeOutEffect } from "./LongFadeOutEffect";
import { MicroFadeInEffect } from "./MicroFadeInEffect";
import { MicroFadeOutEffect } from "./MicroFadeOutEffect";
import { AudioEffectClass, URLProvidingEffectClass } from "types/AudioEffect";

export const URL_PROVIDING_AUDIO_EFFECTS: URLProvidingEffectClass[] = [
  EnhanceMixEffect,
];

export const AUDIO_EFFECTS: AudioEffectClass[] = [
  BackgroundEffect,
  LongFadeInEffect,
  LongFadeOutEffect,
  MicroFadeInEffect,
  MicroFadeOutEffect,
];
